<p-inputNumber
  class="osp-input-element w-full"
  [formControl]="control()"
  [placeholder]="placeholder"
  [class]="cssClass"
  [styleClass]="inputStyleClass"
  [showButtons]="showButtons"
  [format]="format"
  [buttonLayout]="buttonLayout"
  [inputId]="inputId"
  [size]="size"
  [maxlength]="maxLength"
  [tabindex]="tabindex"
  [title]="title"
  [name]="name"
  [autocomplete]="autocomplete"
  [min]="min"
  [max]="max"
  [incrementButtonClass]="incrementButtonClass"
  [decrementButtonClass]="decrementButtonClass"
  [incrementButtonIcon]="incrementButtonIcon"
  [decrementButtonIcon]="decrementButtonIcon"
  [readonly]="readonly"
  [step]="step"
  [allowEmpty]="allowEmpty"
  [locale]="currentLocale"
  [localeMatcher]="localeMatcher"
  [mode]="mode"
  [currency]="currency"
  [currencyDisplay]="currencyDisplay"
  [useGrouping]="useGrouping"
  [minFractionDigits]="minFractionDigits"
  [maxFractionDigits]="maxFractionDigits"
  [prefix]="prefix"
  [suffix]="suffix"
  [showClear]="showClear"
  [autofocus]="autofocus"
  [readonly]="readOnly"
  (focus)="handleFocus($event)"
  (blur)="handleBlur($event)"
  (input)="handleInput($event)"
/>

@if (helpText !== '') {
  <span class="text-color-secondary font-medium ml-2 w-full" textColor="secondary">{{ helpText }}</span>
}
